import React, { useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect, useDispatch, useSelector } from "react-redux";
import * as menteesRequestAction from "../../actions/menteesRequestAction";
import * as baseActions from "../../actions/baseActions";
import UserSidebar from "../../Component/UserSidebar";
import Moment from "moment";
import { Dropdown } from "react-bootstrap";
import RoomList from "./RoomList";
import ScrollToBottom from "react-scroll-to-bottom";
import { useLocation, Link } from "react-router-dom";
import { Button, Form, InputGroup } from "reactstrap";
import { agent } from "../../utils/agent";
import * as API from "../../utils/apiPath";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import ReportUser from "../Forum/reportUser";
import ChatMessage from "./ShowMoreMessage";
import { getDatabase, off, push, onDisconnect, onValue, ref, set, update, get } from "firebase/database";
import PropTypes from "prop-types";
import { fetchUserInfo } from "./Slice/ChatSlice";

function SidebarAddClass(e) {
  e.preventDefault();
  document.getElementById("OnscrollBody").classList.toggle("show_sidebar");
}

const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <button
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    style={{ border: 'none', background: 'none', outline: 'none' }}
  >
    {children}
    <span className="threedots" />
  </button>
));

CustomToggle.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func.isRequired,
};

const Index = () => {

  const userInfo = useSelector((state) => state.userInfo || {});
  const chatCurrentUser = useSelector((state) => state?.chat.currentUser);
  const [chats, setChats] = useState([]);
  const [isMessage, setIsMessage] = useState(true);
  const [roomKey, setRoomKey] = useState(true);
  const [currentUser, setCurrentUser] = useState({});
  const [newchat, setNewchat] = useState({
    roomname: "",
    senderId: "",
    message: "",
    date: "",
    type: "",
  });
  const [userData, setUserData] = useState({});
  const [reportModalShow, setReportModalShow] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = "Chat";
  });

  const database = getDatabase();

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const room = params.get("roomKey");

  useEffect(() => {
    const fetchData = async () => {
      if (!userInfo?.id) return;

      // -----------------------------------
      // USER ONLINE STATUS
      // -----------------------------------
      const userStatusPath = `manage_status/${userInfo.id}`;

      const userStatusRef = ref(
        database,
        userStatusPath
      );

      // Initial online
      await set(userStatusRef, {
        isonline: true,
      });

      // Update status
      await update(userStatusRef, {
        isonline: true,
        status: "I'm online.",
      });

      // Auto offline on disconnect
      const disconnectionRef =
        onDisconnect(userStatusRef);

      disconnectionRef.update({
        isonline: false,
        status: "I'm offline.",
      });

      // -----------------------------------
      // ROOM SETUP
      // -----------------------------------
      setRoomKey(room);

      if (room && typeof room === "string") {
        // -----------------------------------
        // CHAT LISTENER
        // -----------------------------------
        const chatRef = ref(
          database,
          `chats/${room}`
        );

        onValue(chatRef, (snapshot) => {
          const data = snapshotToArray(snapshot);
          setChats(data);
        });

        // -----------------------------------
        // USER ROOM REF
        // -----------------------------------
        const userRoomRef = ref(
          database,
          `users/${userInfo.id}/${room}`
        );

        // RESET UNREAD COUNT
        // TRACK CURRENT OPEN ROOM
        await update(userRoomRef, {
          unread_count: 0,
          current_open_room: room,
        });

        // ROOM DATA LISTENER
        onValue(userRoomRef, (snapshot) => {
          if (snapshot.exists()) {
            setCurrentUser(snapshot.val());
          }
        });
      }
    };

    window.scrollTo(0, 0);

    fetchData();

    // -----------------------------------
    // CLEANUP
    // -----------------------------------
    return () => {
      if (room && userInfo?.id) {
        const cleanupRef = ref(
          database,
          `users/${userInfo.id}/${room}`
        );

        update(cleanupRef, {
          current_open_room: "",
          unread_count: 0,
        });

        const chatRef = ref(database, `chats/${room}`);
        const userRoomRef = ref(database, `users/${userInfo.id}/${room}`);

        off(chatRef);
        off(userRoomRef);
      }
    };
  }, [room, userInfo]);


  const snapshotToArray = (snapshot) => {
    const returnArr = [];
    snapshot.forEach((childSnapshot) => {
      const item = childSnapshot.val();
      item.key = childSnapshot.key;
      returnArr.push(item);
    });
    return returnArr;
  };

  const onChange = (e) => {
    e.persist();
    setIsMessage(false);
    setNewchat({ ...newchat, [e.target.name]: e.target.value });
  };

  const submitMessage = async (e) => {
    e.preventDefault();

    if (newchat.message.trim() === "") return;

    const db = getDatabase();

    const messageText = newchat.message;

    const chat = {
      ...newchat,
      roomname: roomKey,
      senderId: userInfo.id.toString(),
      date: Moment(new Date()).format(
        "DD/MM/YYYY HH:mm:ss"
      ),
      type: "message",
    };

    try {
      // -----------------------------------
      // PUSH MESSAGE
      // -----------------------------------
      const newMessageRef = push(
        ref(db, `chats/${roomKey}`)
      );

      await set(newMessageRef, chat);

      // -----------------------------------
      // RECEIVER ID
      // -----------------------------------
      const receiverId = roomKey
        .split("_")
        .find(
          (id) => id !== userInfo.id.toString()
        );

      // -----------------------------------
      // TIME
      // -----------------------------------
      const time = Moment.utc().valueOf();

      // -----------------------------------
      // SENDER ROOM
      // -----------------------------------
      const senderRoomKey = `users/${userInfo.id}/${roomKey}`;

      const senderRef = ref(
        db,
        senderRoomKey
      );

      await update(senderRef, {
        epoch: -1 * time,
        message: messageText,
        unread_count: 0,
      });

      // -----------------------------------
      // RECEIVER ROOM
      // -----------------------------------
      const receiverRoomKey = `users/${receiverId}/${roomKey}`;

      const receiverRef = ref(
        db,
        receiverRoomKey
      );

      // GET CURRENT DATA
      const snapshot = await get(receiverRef);

      const existingData = snapshot.val();

      const unreadCount =
        existingData?.unread_count || 0;

      // CHECK IF RECEIVER CURRENTLY OPENED SAME CHAT
      const isCurrentRoomOpen =
        existingData?.current_open_room === roomKey;

      await update(receiverRef, {
        epoch: -1 * time,
        message: messageText,
        unread_count: isCurrentRoomOpen
          ? 0
          : unreadCount + 1,
      });

      // -----------------------------------
      // RESET INPUT
      // -----------------------------------
      setNewchat({
        roomname: "",
        senderId: "",
        message: "",
        date: "",
        type: "",
        image: "",
      });

      // -----------------------------------
      // RECEIVER ONLINE STATUS
      // -----------------------------------
      const receiverStatusRef = ref(
        db,
        `manage_status/${receiverId}`
      );

      const statusSnapshot = await get(
        receiverStatusRef
      );

      const statusData = statusSnapshot.val();

      if (!statusData?.isonline) {
        const payload = {
          msg: messageText,
          sender_name: userInfo.full_name,
          receiver_id: receiverId,
          roomKey,
        };

        await agent.post(
          API.SEND_CHAT_MSG,
          payload
        );
      }

      setIsMessage(true);
    } catch (err) {
      console.error(
        "Message send failed",
        err
      );
    }
  };

  const viewReportModal = (e, item) => {
    e.preventDefault();
    setReportModalShow(true);
    setUserData({ item: item, from: "chat" });
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      submitMessage(event)
    }
  };

  const isUserInactive =
    chatCurrentUser?.status === false;

  const isUserRemoved =
    Array.isArray(chatCurrentUser) &&
    chatCurrentUser.length === 0;

  const roomImage =
    userInfo.id === currentUser?.mentor_id
      ? currentUser?.mentee_image
      : currentUser?.mentor_image;

  const fallbackImage =
    chatCurrentUser?.profile_image ||
    chatCurrentUser?.image ||
    chatCurrentUser?.user_image ||
    "";

  useEffect(() => {
    if (
      currentUser?.mentor_id &&
      currentUser?.mentee_id
    ) {
      const selectedUserId =
        userInfo.id === currentUser.mentor_id
          ? currentUser.mentee_id
          : currentUser.mentor_id;

      dispatch(fetchUserInfo(selectedUserId));
    }
  }, [currentUser, userInfo.id, dispatch]);

  return (
    <div>
      <div className="dashboard_outer">
        <UserSidebar />
        <div className="dashboard_inner chetboxouter">
          <div className="d-block mb-3 mb-md-0 mb-md-none toggle_btn_outer">
            <Link
              to=""
              onClick={SidebarAddClass}
              className="toggle_btn d-lg-none"
            >
              <i className="fas fa-bars"></i>
            </Link>
          </div>
          <div className="d-flex flex-wrap mb-3 mb-md-0 mb-md-none toggle_btn_outer chat_main">
            <RoomList userInfo={userInfo} roomKey={room} chatCurrentUser={chatCurrentUser} />
            <div className="message-bar-head mt-0 p-0 h-100">
              {roomKey && (currentUser?.mentor_id || currentUser?.mentee_id) ? (
                <div className="jumbotron_rightsec ">
                  <div className="usr-msg-details">
                    <div className="usr-ms-img">
                      <img
                        // src={
                        //   roomImage?.trim()
                        //     ? roomImage
                        //     : fallbackImage || "/assets/images/no-image1.png"
                        // }
                        src={
                          fallbackImage?.trim()
                            ? fallbackImage
                            : roomImage?.trim()
                              ? roomImage
                              : "/assets/images/no-image1.png"
                        }
                        alt="User"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = "/assets/images/no-image1.png";
                        }}
                      />
                    </div>
                    <div className="usr-mg-info">
                      {userInfo.id === currentUser.mentor_id ? (
                        <h3>{currentUser.mentee_name}</h3>
                      ) : (
                        <h3>{currentUser.mentor_name}</h3>
                      )}
                    </div>
                    <Dropdown
                      style={{
                        zIndex: 999,
                        position: "absolute",
                        top: "10%",
                        right: "0",
                      }}
                    >
                      <Dropdown.Toggle as={CustomToggle} />
                      <Dropdown.Menu
                        style={{ marginTop: "10px" }}
                        size="sm"
                        title=""
                      >
                        <Dropdown.Item
                          onClick={(e) => {
                            viewReportModal(e, currentUser);
                          }}
                        >
                          Report
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <ScrollToBottom
                    className="ChatContent"
                    scrollViewClassName="scrollViewClassName"
                    followButtonClassName="followButtonClassName"
                  >
                    {chats.map((item, idx) => (
                      <div key={item.key} className="MessageBox">
                        {item.type === "join" || item.type === "exit" ? (
                          <div className="ChatStatus">
                            <span className="ChatContentCenter">
                              {item?.message}
                            </span>
                          </div>
                        ) : (
                          <div className="ChatMessage mb-3">
                            <div
                              className={`${item?.senderId === userInfo?.id?.toString()
                                ? "RightBubble"
                                : "LeftBubble"
                                }`}
                            >
                              <span className="MsgDate">{item.date}</span>
                              <div className="chat_message">
                                <ChatMessage text={item?.message} maxLength={350} />
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                  </ScrollToBottom>
                  {isUserInactive || isUserRemoved ? (

                    <footer
                      className="StickyFooter d-flex align-items-center justify-content-center"
                      style={{
                        minHeight: "70px",
                        background: "#f8f9fa",
                        borderTop: "1px solid #e9ecef",
                        padding: "12px 20px",
                      }}
                    >

                      <p
                        className="mb-0 text-center"
                        style={{
                          color: "red",
                          fontSize: "15px",
                          fontWeight: "500",
                          lineHeight: "22px",
                        }}
                      >

                        {isUserRemoved
                          ? "You are no longer able to chat with this user."
                          : "This user is currently inactive and unavailable for messaging."}

                      </p>
                    </footer>

                  ) : (
                    <footer className="StickyFooter">
                      <Form className="MessageForm" onSubmit={submitMessage}>
                        <InputGroup>
                          <TextareaAutosize
                            aria-label="empty textarea"
                            name="message"
                            id="message"
                            minRows={1}
                            maxRows={5}
                            placeholder="Enter message here"
                            onKeyDown={handleKeyDown}
                            value={newchat.message}
                            onChange={onChange}
                          />
                          <Button
                            variant="primary"
                            type="submit"
                            disabled={isMessage}
                            className="ms-2 rounded-full" style={{ cursor: "pointer" }}
                          >
                            <i className="fas fa-paper-plane"></i>
                          </Button>
                        </InputGroup>
                      </Form>
                    </footer>
                  )}
                </div>
              ) : (
                <div className="no-chat">
                  <div>
                    <span className="chat_icon">
                      <i className="far fa-comments"></i>
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {reportModalShow && (
        <ReportUser
          show={reportModalShow}
          userdata={userData}
          onHide={() => setReportModalShow(false)}
          centered
          size="xl"
          className="mentor_modal"
        />
      )}
    </div>
  );
};

function mapStateToProps(state) {
  return {
    menteeRequestData: state.menteeRequestData,
    isAuth: state.isAuth,
    userInfo: state.userInfo,
    updateProfileData: state.updateProfileData,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...menteesRequestAction, ...baseActions },
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
